export default __webpack_public_path__ + "static/media/apple-touch-icon-60x60.b28183bf.png";